export default __webpack_public_path__ + "static/media/a036-4.04ad677b.svg";